// prop-type is a library for typechecking of props
import { Autocomplete } from "@mui/material";
import FormField from "components/FormField";
import PropTypes from "prop-types";
// import { useEffect } from "react";

const LanguagesPicker = ({
  languagesList,
  languages,
  languagesV,
  setFieldValue,
  isObj = false,
  values = {},
  ...rest
}) => (
  <Autocomplete
    key={languagesV?.length}
    id="languages"
    multiple
    filterSelectedOptions
    //   renderTags={() => null}
    options={languagesList}
    onChange={(event, value) => {
      if (value) {
        setFieldValue("languages", value);

        const currentLanguageGuides = values?.languageGuides || [];
        const selectedLanguageCodes = value.map((lang) => lang.code);
        const currentLanguageCodes = (values?.languages || []).map((lang) => lang.code);

        const removedLanguageCodes = currentLanguageCodes.filter(
          (code) => !selectedLanguageCodes.includes(code)
        );

        const addedLanguageCodes = selectedLanguageCodes.filter(
          (code) => !currentLanguageCodes.includes(code)
        );

        // Start with current languageGuides
        let updatedLanguageGuides = [...currentLanguageGuides];

        // Remove languageGuides for removed languages
        if (removedLanguageCodes.length > 0) {
          updatedLanguageGuides = updatedLanguageGuides.filter(
            (guide) => !removedLanguageCodes.includes(guide.language)
          );
        }

        // Add default languageGuides for new languages (with GUIDE type as default)
        if (addedLanguageCodes.length > 0) {
          const newLanguageGuides = addedLanguageCodes.map((languageCode) => ({
            type: "GUIDE",
            language: languageCode,
          }));
          updatedLanguageGuides = [...updatedLanguageGuides, ...newLanguageGuides];
        }

        // Update languageGuides if there were any changes
        if (removedLanguageCodes.length > 0 || addedLanguageCodes.length > 0) {
          setFieldValue("languageGuides", updatedLanguageGuides);
        }
      } else {
        setFieldValue("languages", []);
        setFieldValue("languageGuides", []);
      }
    }}
    value={languagesV}
    getOptionLabel={(option) => (isObj ? option?.name || "" : option || "")}
    // isOptionEqualToValue={(option, value) => option._id === value._id}
    isOptionEqualToValue={(option, value) =>
      isObj ? option.code === value.code : option === value
    }
    renderInput={(params) => (
      <FormField
        {...params}
        {...rest}
        label={languages.label}
        name={languages?.name}
        onChange={() => null}
        // value={languagesV}
      />
    )}
  />
);

// typechecking props for LanguagesPicker
LanguagesPicker.propTypes = {
  languagesList: PropTypes.instanceOf(Array).isRequired,
  languages: PropTypes.instanceOf(Object).isRequired,
  languagesV: PropTypes.instanceOf(Array).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isObj: PropTypes.bool,
  values: PropTypes.instanceOf(Object),
};

export default LanguagesPicker;
